import React from 'react';

/**
 * DataManagementItem: Wraps an entry's display with a header containing actions.
 * Renders a header with the item number and action buttons, and shows children
 * content (typically the EntryData component) below the header.
 *
 * Props:
 * - number: number — the display number for the item (e.g., #1)
 * - actions: { edit?: Function, delete?: Function } — handlers for action buttons
 * - children: ReactNode — content to render inside the item (EntryData)
 */
function DataManagementItem({ number, actions = {}, children }) {
  const { edit, delete: onDelete } = actions || {};
  return (
    <div className="data-item">
      <div className="data-item-header">
        <div className="data-item-number">#{number}</div>
        <div className="data-item-actions">
          {typeof edit === 'function' && (
            <button className="btn btn-sm btn-primary" onClick={edit}>
              <i className="fas fa-edit"></i> Edit
            </button>
          )}
          {typeof onDelete === 'function' && (
            <button className="btn btn-sm btn-danger" onClick={onDelete}>
              <i className="fas fa-trash"></i> Delete
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}

export default DataManagementItem;
